import React, { useEffect, useState } from "react";
import "./CarritoCompra.css";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_API_URL

const Carrito = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || "null");

  const [carrito, setCarrito] = useState(() => JSON.parse(localStorage.getItem("carrito")) || []);
  const [total, setTotal] = useState("0");
  const [infoUser, setInfoUser] = useState({});
  const [cargando, setCargando] = useState(false);


  const obtenerCarritoDB = async () => {
    if (!token) return;
    try {
      const response = await fetch(`${API}/api/carrito/traerCarrito`, {
        headers: { 
            "Authorization": `Bearer ${token}`,
        }
      });
      if (response.ok) {
        const data = await response.json();
 
        const unificados = data.reduce((acc, current) => {
          const prod = current.requestProductos;
          if (acc[prod.id]) {
            acc[prod.id].cantidad += current.cantidad;
          } else {
            acc[prod.id] = {
              id: prod.id,
              dbId: current.id,
              nombre: prod.nombre,
              precio: prod.precio,
              cantidad: current.cantidad,
              imagenUrl: prod.imagenesURLs[0] || ""
            };
          }
          return acc;
        }, {});

        setCarrito(Object.values(unificados));
      }
    } catch (error) {
      console.error("Error al obtener carrito de la DB:", error);
    }
  };

  const sincronizarCarrito = async () => {
    const dataParaEnviar = carrito.map(item => ({
        productoId: item.id,
        cantidad: item.cantidad
    }));

    try {
      const res = await fetch(API + '/api/carrito/sincronizar', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(dataParaEnviar)
      });

      if (res.ok) {
          localStorage.removeItem("carrito");
      }
    } catch (e) { console.error("Error sincronizando", e); }
  };

  useEffect(() => {
    if (token) {
        if (carrito.length > 0) {
            sincronizarCarrito().then(() => obtenerCarritoDB());
        } else {
            obtenerCarritoDB();
        }
    }
  }, [token]);

  const totalPrecios = async () => {
    if (carrito.length === 0) {
      setTotal("0");
      return;
    }
    try {
      const response = await fetch(`${API}/precioTotal/suma`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          productosPreciosList: carrito.map(el => ({
            id: el.id,
            nombreProducto: el.nombre,
            cantidad: el.cantidad
          }))
        })
      });
      const data = await response.json();
      setTotal(data.toLocaleString('es-CO'));
    } catch (error) { console.error("Error al calcular total", error); }
  };

  useEffect(() => {
    totalPrecios();
    if (!token) localStorage.setItem("carrito", JSON.stringify(carrito));
  }, [carrito]);

  const aumentar = async (id) => {
   
    setCarrito(prev => prev.map(item =>
      item.id === id ? { ...item, cantidad: item.cantidad + 1 } : item
    ));

    // 2. Sincronización con DB si está logueado
    if (token) {
      try {
        await fetch(`${API}/api/carrito/agregarCarrito`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({ productoId: id, cantidad: 1 })
        });
      } catch (error) {
        console.error("Error al aumentar en DB:", error);
      }
    }
  };

  const disminuir = async (id) => {
    const itemActual = carrito.find(item => item.id === id);
    if (!itemActual) return;
    if (itemActual.cantidad === 1) {
      eliminar(id, itemActual.dbId);
      return;
    }

    setCarrito(prev => prev.map(item =>
      item.id === id ? { ...item, cantidad: item.cantidad - 1 } : item
    ));

    
    if (token) {
      try {
        await fetch(`${API}/api/carrito/agregarCarrito`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({ productoId: id, cantidad: -1 })
        });
      } catch (error) {
        console.error("Error al disminuir en DB:", error);
      }
    }
  };

  const eliminar = async (productoId, dbId) => {
    if (token && dbId) {
      try {
        await fetch(`${API}/api/carrito/eliminar/${dbId}`, {
          method: 'DELETE',
          headers: { "Authorization": `Bearer ${token}` }
        });
      } catch (e) { console.error("Error al borrar en DB", e); }
    }
    
    setCarrito(prev => prev.filter(item => item.id !== productoId));
  };

  const pagar = async () => {
    if (!user || !token) {
      alert("Debes iniciar sesión para comprar");
      navigate("/login");
      return;
    }
    setCargando(true);
    try {
      const responsePedido = await fetch(`${API}/pedido/crear`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({
          idUsuario: user.id,
          productosPreciosList: carrito.map(el => ({ id: el.id, cantidad: el.cantidad }))
        })
      });
      const dataPedido = await responsePedido.json();
      const pedidoId = dataPedido.datos;

      const responseWompi = await fetch(`${API}/api/pagos/wompi/${pedidoId}`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
        }
      });
      const dataWompi = await responseWompi.json();
      if (dataWompi.checkoutUrl) {
        localStorage.removeItem("carrito");
        window.location.href = dataWompi.checkoutUrl;
      }
    } catch (error) {
      alert("Error al procesar el pago.");
    } finally { setCargando(false); }
  };

  return (
    <div className="carrito-page">
      <div className="carrito-container">
        <header className="carrito-header">
          <h2>🛒 Tu Carrito</h2>
          <span className="items-count">{carrito.length} productos</span>
        </header>

        {carrito.length === 0 ? (
          <div className="carrito-vacio-box">
            <p>Tu bolsa de compras está vacía</p>
            <button onClick={() => navigate("/")} className="btn-volver">Ir a la tienda</button>
          </div>
        ) : (
          <div className="carrito-grid">
            <div className="carrito-items">
              {carrito.map(item => (
                <div className="carrito-item" key={item.id}>
                  <img
                    className="item-imagen"
                    src={item.imagenUrl.startsWith('http') ? item.imagenUrl : `${API}${item.imagenUrl}`}
                    alt={item.nombre}
                  />
                  <div className="item-info">
                    <h4 className="item-nombre">{item.nombre}</h4>
                    <p className="item-precio-unitario">
                      Unitario: ${item.precio ? item.precio.toLocaleString('es-CO') : 0}
                    </p>
                    <div className="item-controles">
                      <div className="selector-cantidad">
                        <button onClick={() => disminuir(item.id)}>−</button>
                        <span>{item.cantidad}</span>
                        <button onClick={() => aumentar(item.id)}>+</button>
                      </div>
                      {/* Pasamos item.id para el front e item.dbId para el back */}
                      <button onClick={() => eliminar(item.id, item.dbId)} className="btn-eliminar-text">Eliminar</button>
                    </div>
                  </div>
                  <div className="item-subtotal-column">
                    <p className="subtotal-label">Subtotal</p>
                    <p className="subtotal-valor">
                      ${(item.precio * item.cantidad).toLocaleString('es-CO')}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <aside className="carrito-resumen">
              <div className="resumen-card">
                <h3>Resumen de orden</h3>
                <div className="resumen-fila"><span>Productos</span><span>${total}</span></div>
                <div className="resumen-fila"><span>Envío</span><span className="gratis">Gratis</span></div>
                <hr />
                <div className="resumen-fila total"><span>Total</span><span>${total}</span></div>
                <button onClick={pagar} className="pagar-btn" disabled={cargando}>
                  {cargando ? "Procesando..." : "Finalizar Compra"}
                </button>
                <p className="seguridad-txt">🔒 Pago 100% seguro con Wompi</p>
              </div>
            </aside>
          </div>
        )}
      </div>
    </div>
  );
};

export default Carrito;